import SectionHeading from '@/components/feature/SectionHeading';
import { certificates } from '@/mocks/homeData';

const marqueeItems = [...certificates, ...certificates];

export default function CertificatesSection() {
  return (
    <section id="certificates" className="w-full bg-background-100 py-14 md:py-20 overflow-hidden">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="Quality Assurance"
          title="Our Certificates & Accreditations"
          description="Verified manufacturing and quality credentials that stand behind every Ayurvedic formulation we produce."
        />
      </div>

      <div className="relative mt-10 md:mt-14">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {marqueeItems.map((item, index) => (
            <div key={`${item.id}-${index}`} className="w-64 md:w-72 shrink-0 px-3">
              <div className="h-full flex flex-col rounded-lg border border-background-200 bg-background-50 p-4">
                <div className="h-52 flex items-center justify-center bg-background-100 rounded-lg overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} - Best Research Pharma`}
                    title={`${item.title} - Best Research Pharma`}
                    className="max-w-[85%] max-h-[90%] object-contain"
                  />
                </div>
                <p className="mt-3 text-center text-xs font-semibold text-primary-700 leading-snug">{item.title}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-16 md:w-28 bg-gradient-to-r from-background-100 to-transparent"></div>
        <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-16 md:w-28 bg-gradient-to-l from-background-100 to-transparent"></div>
      </div>

      <div className="w-full px-4 md:px-8 mt-8 md:mt-10">
        <div className="mx-auto max-w-3xl flex items-start gap-3 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 shrink-0">
            <i className="ri-medal-line text-lg"></i>
          </span>
          <p className="text-xs md:text-sm leading-relaxed text-accent-900">
            <strong className="font-semibold">RDS Pain Balm®</strong> is a registered trade mark of Best Research Pharma
            — verified and protected under the Trade Marks Act, alongside our State Licence, Schedule T GMP, ISO
            9001:2015 and Halal certifications.
          </p>
        </div>
      </div>
    </section>
  );
}